export default __webpack_public_path__ + "static/media/Phylactere_alone.98bde880.png";